import {ApiConfigs, authKioskHeader} from '../_helpers';

export const displayService = {
    login,
    autoLogin,
    logout,
    refresh,
    getQueueById,
    getWaitingList,
    textToSpeech,
    getInServiceTickets,
    getVoiceTelling,
    refreshDisplay,
    ping,
    generateAuthCode
};

function textToSpeech(text, language) {
    //AIzaSyCCu5z_wOjyw1iBONIykXU8dms7RfOKwCQ
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            "audioConfig": {
                "audioEncoding": "LINEAR16",
                "pitch": 0,
                "speakingRate": 1.15
            },
            "input": {
                "text": text
            },
            "voice": {
                "languageCode": language,
                "name": language
            }
        })
    };

    return fetch(`https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyCCu5z_wOjyw1iBONIykXU8dms7RfOKwCQ`, requestOptions)
        .then(handleResponse).catch(handleRejected)
}

function login(key, secret) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, secret })
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.login}`, requestOptions)
        .then(handleResponse)
        .then(display => {
            // login successful if there's a jwt token in the response
            if (display.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('display', JSON.stringify(display));
            }
            return display;
        });
}


function autoLogin(key, token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.autoLogin
        .replace(':key', key).replace(':token', token)}`, requestOptions)
        .then(handleResponse)
        .then(display => {
            // login successful if there's a jwt token in the response
            if (display.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('display', JSON.stringify(display));
            }
            return display;
        });
}


function logout() {
    // remove user from local storage to log user out
    const requestOptions = {
        method: 'POST',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.logout}`, requestOptions)
        .then(handleResponse)
        .then(function () {
            localStorage.removeItem('display');
        }).catch(handleRejected);
}

function refresh() {
    const requestOptions = {
        method: 'GET',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.refresh}`, requestOptions)
        .then(handleResponse)
        .then(display => {
            localStorage.setItem('display', JSON.stringify(display));
            return display;
        }).catch(handleRejected);
}


function refreshDisplay() {
    const requestOptions = {
        method: 'GET',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.refresh}`, requestOptions)
        .then(handleResponse)
        .then( display => {
                localStorage.setItem('display', JSON.stringify(display));
                return display;
        }).catch(handleRejected);
}

function getInServiceTickets(queues) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({queues: queues})
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.queues.getInServiceTickets}`, requestOptions).then(handleResponse).catch(handleRejected);
}


function getVoiceTelling(data) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.queues.voiceTelling}`, requestOptions).then(handleResponse).catch(handleRejected);
}


function getQueueById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authKioskHeader()
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.queues.get.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleRejected);
}

function getWaitingList(id) {
    const requestOptions = {
        method: 'GET',
        headers: authKioskHeader()
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.queues.getWaitingList.replace(':id', id)}`, requestOptions).then(handleResponse).catch(handleRejected);
}

function ping(payload) {
    const requestOptions = {
        method: "POST",
        headers: {...authKioskHeader()},
        body: payload
    }

    return fetch(`${ApiConfigs.base_display_url + ApiConfigs.display.ping}`, requestOptions)
        .then(handleResponse).catch(handleRejected);
}

function generateAuthCode() {
    const requestOptions = {
        method: 'GET',
        headers: authKioskHeader()
    };

    return fetch(`${ApiConfigs.base_display_url+ApiConfigs.display.generateAuthCode}`, requestOptions).then(handleResponse).catch(handleRejected);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('display');
                // auto logout if 401 response returned from api
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

function handleRejected(exception) {
    console.log(exception);
}